import i18next from "i18next";
import global_ar from "./locales/ar.json";
import global_en from "./locales/en.json";

const language = localStorage.getItem("language");

const userLanguage = navigator.language || navigator.userLanguage;
let languageCode = userLanguage.split("-")[0];

i18next.on("initialized", (options) => {
  document.documentElement.dir = i18next.dir(options.lng);
  document.documentElement.lang = options.lng;
});

i18next.on("languageChanged", (lng) => {
  localStorage.setItem("language", lng);
  document.documentElement.dir = i18next.dir(lng);
  document.documentElement.lang = lng;
});

i18next.init({
  interpolation: { escapeValue: false },
  lng: language ? language : languageCode,
  resources: {
    en: {
      global: global_en,
    },
    ar: {
      global: global_ar,
    },
  },
});

export default i18next;
